import React, { useState } from "react";
import { Box, Typography } from "@mui/material";

export default function CustomSelectableCard({
    title,
    description,
    icon,
    selected,
    onSelect,
    disabled,
    width,
    isOptional,
    multiple = false,
    margin,
    padding,
}) {
    const [isHovered, setIsHovered] = useState(false);

    const handleClick = () => {
        if (!disabled && onSelect) {
            if (multiple) {
                onSelect(!selected); // Allow toggling for multiple selection
            } else if (!selected) {
                onSelect(true); // Only allow selection if not already selected
            }
        }
    };

    return (
        <Box
            onClick={handleClick}
            onMouseEnter={() => setIsHovered(true)}
            onMouseLeave={() => setIsHovered(false)}
            sx={{
                display: "flex",
                alignItems: "center",
                gap: 2,
                padding: padding || "10px",
                margin: margin || "10px 0",
                width: width || "100%",
                borderRadius: "8px",
                cursor: disabled ? "not-allowed" : "pointer",
                backgroundColor: selected || isHovered ? "#F5F5F5" : "white", // Updated background color
                border: "none", // Removed border
                transition: "all 0.3s ease",
            }}
        >
            {icon && (
                <Box
                    sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        width: "40px",
                        height: "40px",
                        borderRadius: "50%",
                        backgroundColor: "white",
                        border: "1px solid #E6E6E6",
                    }}
                >
                    {icon}
                </Box>
            )}
            <Box>
                <Typography
                    sx={{
                        fontFamily: "FunnelSans",
                        fontWeight: 500,
                        fontSize: "16px",
                        color: "#1D1B1B",
                        justifyContent: "space-between",
                        display: "flex",
                    }}
                >
                    {title}
                    {isOptional ? <span className="optional-label">Optional</span> : null}
                </Typography>
                <Typography
                    sx={{
                        fontFamily: "FunnelSans",
                        fontWeight: 400,
                        fontSize: "14px",
                        color: "#74788D",
                    }}
                >
                    {description}
                </Typography>
            </Box>
        </Box>
    );
}